import { useAuth } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';
import { createAxiosInstance } from '../services/api/axios.config';

export const useApi = () => {
    const { getToken } = useAuth();
    const { i18n } = useTranslation();

    const abortController = new AbortController();
    const axiosInstance = createAxiosInstance(() => getToken(), i18n, abortController.signal);

    return { axiosInstance, abortController };
};